type Amount = { default: number } & { [year: string]: number }
export function currentAmount(amount: Amount): number {
  const year = new Date().getFullYear()
  return amount[year.toString()] ?? amount.default
}
